import { defineDocument } from '../../schema';
export const blogTheReturnOfTheKingEgoManiacsReimaginedDocument = defineDocument({
    id: 'blog:the-return-of-the-king-ego-maniacs-reimagined',
    kind: 'blog',
    slug: 'the-return-of-the-king-ego-maniacs-reimagined',
    route: '/blog/the-return-of-the-king-ego-maniacs-reimagined',
    seo: {
        title: 'The Return of the King: Ego Maniacs, Reimagined',
        description: 'High school superlatives meet musical chairs in re-release of our most popular game',
        imageAsset: 'coverEgoManiacs',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Airhead Blog',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'The Return of the King: Ego Maniacs, Reimagined',
            },
        ],
        description: [
            {
                type: 'text',
                text: 'High school superlatives meet musical chairs in re-release of our most popular game',
            },
        ],
        imageAsset: 'coverEgoManiacs',
        imageAlt: 'Ego Maniacs cover art',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2025-10-10T00:00:00.000Z'),
        tags: ['games'],
    },
    sections: [
        {
            id: 'article',
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: "We've all been there: staring at a high school yearbook, wondering who on earth decided you were \"Most Likely to Own 15 Cats.\" There's a weird social messiness that happens when your friends start putting you in a box, and it's even stranger when you're the one convincing them to.",
                        },
                    ],
                },
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: "That's the energy we wanted to bottle up for ",
                        },
                        {
                            type: 'link',
                            href: '/discover/games/ego-maniacs',
                            children: [
                                {
                                    type: 'text',
                                    text: 'Ego Maniacs',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: ', one of the original fan-favorites from our beta days. Today, we are thrilled to announce Ego Maniacs is officially back, reimagined and rebuilt for our new platform.',
                        },
                    ],
                },
            ],
            sections: [
                {
                    id: 'article__the-art-of-the-self-nomination',
                    title: [
                        {
                            type: 'text',
                            text: 'The Art of the Self-Nomination',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'When we first sat down to design Ego Maniacs, we were chasing a very specific feeling: ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'the chaos of musical chairs mixed with the cringe of high school yearbook awards.',
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            type: 'quote',
                            content: [
                                {
                                    type: 'text',
                                    text: 'I loved the idea of people voting themselves ridiculous awards in a game where the honors rarely feel like a win.',
                                },
                            ],
                            attribution: [
                                {
                                    type: 'text',
                                    text: 'Jay, Developer',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "The goal wasn't just to win; it was to win for something ridiculous. In Ego Maniacs, players vote on who deserves various \"Ego Awards.\" Win an award, and you're safe for the round. Fail to secure a trophy, and you're eliminated.",
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__infinite-awards-infinite-cringe',
                    title: [
                        {
                            type: 'text',
                            text: 'Infinite Awards, Infinite Cringe',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Rather than pulling from a static list of titles, the awards (and their custom trophy images) are generated fresh every single time you play.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "This means the game stays unpredictable even if you're playing with the same group of friends every Friday night. Because the awards are generated on the fly, you'll never find yourself winning the same trophy twice; every session brings a brand-new set of accolades for your friends to fight over.",
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__he-s-literally-wearing-mismatched-socks',
                    title: [
                        {
                            type: 'text',
                            text: '"He\'s Literally Wearing Mismatched Socks!"',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'We knew the game "worked" during a playtest where a group of close friends started a heated debate over who was "Most Likely to Wear Mismatching Socks." In the middle of the argument, one player realized he was currently wearing mismatched socks. The room erupted in laughter, and he easily won the award.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "That's the \"Ego Maniacs\" magic: it's a game that thrives when played with people who know (and aren't afraid to roast) each other and themselves.",
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__the-strategy-know-thy-self',
                    title: [
                        {
                            type: 'text',
                            text: 'The Strategy: Know Thy Self',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'While the game is "low brain power," there is a definite strategy to survival. Since you are encouraged to nominate yourself, the pro-tip is to ',
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'nominate yourself for the awards you think others will nominate you for',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'To stay safe, you need a decisive win. Splitting the vote could lead to a 50-50 toss-up, and you definitely don\'t want to leave your survival to a judge you may have slighted with your own nominations. You have to read the room: do you actually have the "Best Elvis Impersonation," or should you lean into your "Worst Parallel Parker" reputation to secure the trophy?',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__keeping-the-dead-alive',
                    title: [
                        {
                            type: 'text',
                            text: 'Keeping the Dead Alive',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "One of the biggest hurdles with elimination games is making sure the first person out isn't just sitting around scrolling on their phone. In Ego Maniacs, ",
                                },
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'eliminated players remain in the game',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ". Even if you lose your shot at the final crown, you still vote on every award and act as a crucial tie-breaker. You might be out of the running, but you still get to decide who joins you in the loser's circle.",
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__more-than-just-a-re-release',
                    title: [
                        {
                            type: 'text',
                            text: 'More Than Just a Re-Release',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "Ego Maniacs isn't the only thing moving into a new era. This update includes several upgrades:",
                                },
                            ],
                        },
                        {
                            type: 'list',
                            items: [
                                [
                                    {
                                        type: 'strong',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'Improved Reliability:',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ' Additional under-the-hood performance tweaks to the new platform.',
                                    },
                                ],
                                [
                                    {
                                        type: 'strong',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'Lobby Vibes:',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: " We've added a few new tunes to the lobby to keep the energy up while you wait for the squad to join.",
                                    },
                                ],
                            ],
                        },
                    ],
                },
                {
                    id: 'article__are-you-an-ego-maniac',
                    title: [
                        {
                            type: 'text',
                            text: 'Are you an Ego Maniac?',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "We've poured a lot of love into making this the most polished version of Ego Maniacs yet, but your feedback is crucial! Hop into a game, test out the new UI, and let us know what you think. What legendary awards did you win? Did a judge make a controversial call? Share your favorite moments in ",
                                },
                                {
                                    type: 'link',
                                    href: 'https://discord.gg/rfFTVAqHwH',
                                    children: [
                                        {
                                            type: 'text',
                                            text: "Poppy's Pals Discord",
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'strong',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Ready to claim your trophy?',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' ',
                                },
                                {
                                    type: 'link',
                                    href: '/library',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Start a game of Ego Maniacs now.',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'article-actions',
            widgets: [
                {
                    type: 'relatedDocuments',
                    limit: 4,
                },
            ],
        },
    ],
});
//# sourceMappingURL=the-return-of-the-king-ego-maniacs-reimagined.js.map